<template>
  <div class="bg-white py-5">
    <div class="container">
      <div class="highlights-section">
          <div class="highlights-divider"></div>
        <h1>
          Company Highlights
        </h1>
        <article class="highlights">
          <div class="highlight">
            <strong>OOYYO is one of Europe’s leading car price comparison websites</strong>
            (Kayak for European car buyers). <strong>10 million car buyers</strong> and
            international dealers visit OOYYO each year to research car sale
            information, on millions of cars, that is aggregated and <strong>analyzed
            using AI by OOYYO</strong> from thousands of information sources
          </div>
          <div class="highlight">
            <strong>Est. 17 million used cars were sold</strong> in key European markets at est.
            value of $200 billion. <strong>It is estimated that OOYYO website visitors
            purchase</strong> 2 million cars per year or over 10% of the European used
            car market
          </div>
          <div class="highlight">
            <strong>
            All of OOYYO’s traffic is organic and led to 140 million page views
            over the last year. It does not spend any money on paid advertising.
            Average visitor acquisition cost is $0
            </strong>
          </div>

          <div class="highlight">
            Management team has decades of successful experience in the
            ecommerce industry <strong>(including machine learning related to SEO and
            customer acquisition)</strong>
          </div>
        </article>
        <div class="highlights-divider"></div>
        <article class="highlights">
          <div class="highlight">
            <strong>CEO previously co-founded</strong> (invested / recruited team) Wowd a
            distributed social search engine <strong>sold to Facebook in 2012</strong>
          </div>
          <div class="highlight"></div>
          <div class="highlight">
            <strong>CEO helped build out</strong> the CarStory.com team <strong>(Acquired by Vroom in
            2021)</strong>
          </div>
        </article>
      </div>
    </div>
  </div>
</template>
